export const AGENT_TYPES = Object.freeze({
  APPLICATION_STATUS: "Application Status Agent",
  ELIGIBILITY_REVIEW: "Eligibility Review Agent",
  INTAKE_REVIEW_AGENT: "Intake Review Agent",
  DOCUMENT: "Document Quality Agent",
  BENEFITS: "Benefits Agent",
});

export const AGENT_NAME_TO_ID = {
  [AGENT_TYPES.INTAKE_REVIEW_AGENT]: "review-intake-a1",
  [AGENT_TYPES.DOCUMENT]: "DocumentProcessingAgent",
  [AGENT_TYPES.BENEFITS]: "benefit-agent-b1",
  [AGENT_TYPES.ELIGIBILITY_REVIEW]: "eligibility-review-agent",
  [AGENT_TYPES.APPLICATION_STATUS]: "application-status-agent",
};
